<template>
    <div class="flex flex-col flex-wrap items-center justify-start w-full px-4 mt-12 md:flex-row md:pl-0">
        <div class="order-2 w-full md:w-6/12 md:order-1">
            <ul class="flex flex-wrap w-full">
                <li v-for="category in categories" :key="category.id"  @mouseover="selectedCategory = category.id" class="w-6/12 p-3 md:w-4/12 md:p-4">
                    <a :href="'/category/' + category.slug" class="flex flex-col items-center justify-center p-4 text-center bg-white rounded-lg shadow-xl category-icon h-36 w-36 md:h-48 md:w-48 hover:bg-green-500 hover:text-black">
                        <img :src="category.icon" :alt="category.name" width="60">
                        <span>{{category.name}}</span>
                    </a>
                </li>
            </ul>
        </div>
        <div class="flex flex-col items-center justify-center order-1 w-full md:flex-row md:w-6/12 md:order-2">
            <div v-if="!selectedCategory">
                <h3 class="text-4xl font-bold text-center text-pink-600 md:text-left">Seleziona<br>un argomento</h3>
                <div>
                    <span class="inline-block w-40 h-1 bg-pink-600 rounded-full"></span>
                    <span class="inline-block w-3 h-1 ml-1 bg-pink-600 rounded-full"></span>
                    <span class="inline-block w-1 h-1 ml-1 bg-pink-600 rounded-full"></span>
                </div>  
            </div>
            
            <div class="hidden px-24 md:block">

            
            <div v-if="selectedCategory == 1">
                <span class="text-6xl font-bold text-pink-600">Marketing</span> 
                <p class="py-2 text-sm text-gray-700">Sai come rapire l'attenzione delle persone per farle diventare clienti? Impara a differenziarti sul mercato attraverso una strategia di marketing che colpisca in pieno le esigenze inespresse dei tuoi clienti!</p>
                <a href="/category/marketing" class="block px-6 py-1 my-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:shadow-custom hover:bg-pink-600">trova eventi</a>
            </div>

            <div v-if="selectedCategory == 2">
                <span class="text-6xl font-bold text-pink-600">Gestione<br>del personale</span>
                <p class="py-2 text-sm text-gray-700">Scopri come gli imprenditori di successo ottengono il meglio dai propri collaboratori, come fare team building. Impara a gestire le eccezioni e i collaboratori difficili.</p> 
                <a href="/category/gestione-del-personale" class="block px-6 py-1 my-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:shadow-custom hover:bg-pink-600">trova eventi</a>
            </div>

            <div v-if="selectedCategory == 3">
                <span class="text-6xl font-bold text-pink-600">Gestione<br>finanziaria</span>
                <p class="py-2 text-sm text-gray-700">Monetizza il tuo valore! Migliora la tua capacità di gestire il denaro e costruisci il tuo piano finanziario: i tuoi 'costi' diventeranno investimenti!</p>
                <a href="/category/gestione-finanziaria" class="block px-6 py-1 my-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:shadow-custom hover:bg-pink-600">trova eventi</a>
            </div>

            <div v-if="selectedCategory == 4">
                <span class="text-6xl font-bold text-pink-600">Leadership</span>
                <p class="py-2 text-sm text-gray-700">Non essere un capo, diventa leader! Impara i segreti per diventare un punto di riferimento per i tuoi collaboratori trainandoli verso risultati straordinari!</p>
                <a href="/category/leadership" class="block px-6 py-1 my-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:shadow-custom hover:bg-pink-600">trova eventi</a>
            </div>

            <div v-if="selectedCategory == 5">
                <span class="text-6xl font-bold text-pink-600">Vendite</span>
                <p class="py-2 text-sm text-gray-700">Incrementa le tue vendite, rendi più efficaci i tuoi venditori, aumenta il giro dei tuoi affari e i tuoi utili. Impara la causatività, la scala dei toni emozionali, la piramide rovesciata e molto altro.</p>
                <a href="/category/vendite" class="block px-6 py-1 my-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:shadow-custom hover:bg-pink-600">trova eventi</a>
            </div>

            <div v-if="selectedCategory == 6">
                <span class="text-6xl font-bold text-pink-600">Crescita personale</span>
                <p class="py-2 text-sm text-gray-700">Mettiti alla prova e combatti i tuoi limiti! Prendi consapevolezza dei freni che stanno rallentando la tua crescita e il tuo benessere: decidi di cambiare!</p>
                <a href="/category/crescita-personale" class="block px-6 py-1 my-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:shadow-custom hover:bg-pink-600">trova eventi</a>
            </div>

            <div v-if="selectedCategory == 7">
                <span class="text-6xl font-bold text-pink-600">Investimenti</span>
                <p class="py-2 text-sm text-gray-700">Segui i consigli degli investitori che hanno accumulato ricchezze, impara a creare entrate passive, a capire l'andamento dei mercati, le crypto e molto altro così da far lavorare i tuoi soldi per te che ti consentano di mantenere o accrescere la tua Azienda e il tuo benessere.</p>
                <a href="/category/investimenti" class="block px-6 py-1 my-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:shadow-custom hover:bg-pink-600">trova eventi</a>
            </div>

            <div v-if="selectedCategory == 8">
                <span class="text-6xl font-bold text-pink-600">Management</span>
                <p class="py-2 text-sm text-gray-700">Non essere schiavo della tua azienda! Impara i principi del management per poter supervisionare e controllare la tua impresa anche quando non ci sei!</p>
                <a href="/category/management" class="block px-6 py-1 my-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:shadow-custom hover:bg-pink-600">trova eventi</a>
            </div>

            </div>

        </div>
    </div>
</template>


<script>
    export default {
        props: [
            'categories'
        ],
        data() {
            return {
                selectedCategory: null,
            };
        },
    }
</script>
<style scoped>
    .category-icon:hover {
        filter: invert(1);
    }
</style>